// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"LZ-z"};